export default __webpack_public_path__ + "static/image-section-steak-4508009dea3e5a80bcdfc86137461267.webp";